import React, { useState, useEffect } from "react";
import AntDesignTable from "../common/antTable/AntDesignTable";
import { message } from "antd";
import { ref, onValue } from "firebase/database";
import { database } from "../../firebaseConfig";
import AppointmentButton from "../common/appoinmentButton/AppoinmentButton";
import { useAuth } from "../context/AuthContext";
import { API_URL } from "../../config";
import moment from "moment";

const AppointmentContainer = () => {
  const [appointments, setAppointments] = useState([]);
  const [rejoinVisibleRowId, setRejoinVisibleRowId] = useState(null);
  const { loginDoctorDetails } = useAuth();
  const apiBaseUrl = API_URL;
  useEffect(() => {
    const fetchAppointmentsFromFirebase = () => {
      const appointmentRef = ref(database, "appointments");
      const today = new Date();
      const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

      const unsubscribe = onValue(
        appointmentRef,
        async (snapshot) => {
          const appointmentData = snapshot.val();
          if (appointmentData) {
            const filteredData = Object.keys(appointmentData)
              .map((key) => ({
                id: key,
                ...appointmentData[key],
              }))
              .filter((appointment) => {
                const creationDate = new Date(appointment.creation_datetime);
                return (
                  creationDate >= startOfToday &&
                  creationDate < endOfToday &&
                  appointment.status !== "COMPLETED"
                );
              });

            try {
              const response = await fetch(
                `${apiBaseUrl}/appointment/all/?status=UPCOMING&status=IN_PROGRESS&detail=patient`
              );
              const data = await response.json();

              const today = moment().startOf("day");
              const filteredAppointments = data.filter(
                (appointment) =>
                  appointment.scheduled_datetime == null ||
                  moment(appointment.scheduled_datetime).isSame(today, "day")
              );
              setAppointments(filteredAppointments);
            } catch (error) {
              console.error("Error fetching appointments:", error);
              message.error("Failed to fetch new appointments from API.");
              setAppointments(filteredData);
            }
          }
        },
        (error) => {
          console.error("Error fetching data from Firebase:", error);
          message.error("Failed to load data from Firebase.");
        }
      );

      return unsubscribe;
    };

    const unsubscribe = fetchAppointmentsFromFirebase();
    return () => unsubscribe();
  }, []);

  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text, row) => {
        if (row.tablet_id) {
          return "Tablet";
        } else if (row.kiosk_id) {
          return "Kiosk";
        } else if (row.mobile) {
          return "Mobile";
        } else {
          return "-";
        }
      },
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text, row) => {
        const { tablet_id, kiosk_id } = row;
        const id = tablet_id ? tablet_id : kiosk_id ? kiosk_id : "-";
        return <div>{id}</div>;
      },
    },
    {
      title: "Patient Name",
      dataIndex: "patient_name",
      key: "patient_name",
      sorter: {
        compare: (a, b) => a.first_name - b.first_name,
        multiple: 3,
      },
      render: (text, row) => {
        const { first_name, last_name } = row.patient_details || {};
        return first_name && last_name ? `${first_name} ${last_name}` : "-";
      },
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (text, row) => row.patient_details?.gender || "-",
      sorter: {
        compare: (a, b) =>
          a.patient_details?.gender - b.patient_details?.gender,
        multiple: 3,
      },
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (text, row) => row.patient_details?.age || "-",
      sorter: {
        compare: (a, b) => a.patient_details?.age - b.patient_details?.age,
        multiple: 3,
      },
    },
    {
      title: "Start Time ",
      dataIndex: "scheduled_datetime",
      key: "scheduled_datetime",
      render: (text, row) =>
        text == null ? "-" : moment(text).format("DD/MM/YYYY LT"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, row) => (
        <AppointmentButton
          row={row}
          loginDoctorDetails={loginDoctorDetails}
          rejoinVisibleRowId={rejoinVisibleRowId}
          setRejoinVisibleRowId={setRejoinVisibleRowId}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <AntDesignTable columns={columns} tableData={appointments} rowKey="id" />
    </React.Fragment>
  );
};

export default AppointmentContainer;
